// BlogLayoutTuto.tsx
import React from 'react';
import Image from 'next/image';
import { Post } from '../PostType'; // Utilisez vos types définis

interface BlogLayoutTutoProps {
    post: Post;
}

const BlogLayoutTuto: React.FC<BlogLayoutTutoProps> = ({ post }) => {
    return (
        <article className="max-w-4xl mx-auto p-4 bg-white rounded-lg shadow">
            <h1 className="text-3xl font-bold text-center my-6">{post.content.h1}</h1>
            <Image
                src={post.imageUrl}
                alt={`Image for ${post.title}`}
                width={700}
                height={475}
                className="w-full object-cover rounded-t-lg"
                layout='responsive'
            />
            <div className="px-6 py-4">
                <p className="text-lg my-2">{post.content.intro}</p>
                {post.content.sections && post.content.sections.map((section, index) => (
                    <div key={index} className="my-4">
                        <h2 className="text-2xl font-semibold">{section.h2}</h2>
                        <p className="text-gray-600 mt-2">{section.paragraph}</p>
                    </div>
                ))}
                <p className="text-lg my-2">{post.content.conclusion}</p>
                <button
                    onClick={() => {/* Handler pour l'action du bouton */ }}
                    className="mt-6 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                >
                    {post.content.callToAction}
                </button>
            </div>
            <div className="px-6 pt-4 pb-2">
                <div className="flex justify-between items-center flex-col sm:flex-row gap-4">
                    <div className="flex gap-2 items-center text-sm">
                        {post.category.map((category, index) => (
                            <span key={index} className="bg-gray-200 rounded-full px-3 py-1 font-semibold text-brand">{category}</span>
                        ))}
                    </div>
                    <div className="text-sm text-gray-500">
                        <span className="font-medium">{post.author}</span>
                        <span className="mx-2">•</span>
                        <time dateTime={post.date}>{new Date(post.date).toLocaleDateString()}</time>
                    </div>
                </div>
            </div>
        </article>
    );
};

export default BlogLayoutTuto;
